import axios from 'axios';
import { useState } from 'react';
import { WithRouterProps } from 'react-router';

import { getCreatorApiUrl } from '@client/components/api-urls';
import { sprinkles } from '@design-system/sprinkles.css';
import mailNotificationLogo from '/static/images/mail-subscription/logo.svg';

export const MailSubscription: React.FC<WithRouterProps> = ({
  location,
  params,
}) => {
  const [resubscribed, setResubscribed] = useState(false);
  const handleOnClick = async () => {
    const url = `/email/resubscribe/${params?.email}`;

    await axios
      .post(getCreatorApiUrl(url), {
        token: location.query?.token,
        messageType: location.query?.messageType,
      })
      .then(() => {
        setResubscribed(true);
      });
  };

  return (
    <div
      className={`flex items-center justify-center h-screen ${sprinkles({
        fontFamily: 'visuelt',
      })}`}
    >
      <div className="flex flex-col items-center gap-5 w-[554px]">
        <a href="https://playbookapp.io" target="_blank" rel="noreferrer">
          <img
            src={mailNotificationLogo}
            alt="Playbook logo"
            className="w-[200px]"
          />
        </a>
        <div className="bg-white rounded-lg overflow-hidden">
          <div className="flex flex-col items-center gap-5 ">
            <img
              className="bg-gray-300"
              src={'/static/images/mail-subscription/collage.png'}
            />
            <div className="flex flex-col items-center gap-5 p-5 pt-0 pb-10">
              {resubscribed ? (
                <div className="text-center text-black text-3xl font-bold">
                  You successfully resubscribed!
                </div>
              ) : (
                <>
                  <div className="text-center text-black text-3xl font-bold">
                    We’ll Miss You!
                  </div>
                  <div className="text-center text-black text-base font-medium">
                    You’ve been unsubscribed from Playbook. Should you ever
                    decide to return, we’ll be here with open arms.
                  </div>
                  <div className="flex flex-col items-center gap-3">
                    <button
                      onClick={handleOnClick}
                      className="px-4 py-2 bg-purple-800 rounded-lg border-0 appearance-none"
                    >
                      <div className="text-center text-white text-base font-medium">
                        Re-subscribe
                      </div>
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
          <div className="flex items-center gap-3 p-4 bg-purple-200">
            <div className="flex-1 text-center text-purple-800 text-xs font-bold uppercase">
              Thanks for being a part of our community!
            </div>
          </div>
        </div>
        <div className="flex flex-col items-center gap-5">
          <div className="flex items-start">
            <div className="px-2 py-1 border-r border-solid border-gray-200">
              <a
                href="https://playbook-docs.helpscoutdocs.com/"
                target="_blank"
                rel="noreferrer"
                className="text-center text-black text-xs font-bold uppercase"
              >
                Help Center
              </a>
            </div>
            <div className="px-2 py-1 border-r border-solid border-gray-200">
              <a
                href="https://playbookapp.io/contact"
                target="_blank"
                rel="noreferrer"
                className="text-center text-black text-xs font-bold uppercase"
              >
                Contact
              </a>
            </div>
            <div className="px-2 py-1 border-r border-solid border-gray-200">
              <a
                href="https://playbookapp.io/terms-of-use"
                target="_blank"
                rel="noreferrer"
                className="text-center text-black text-xs font-bold uppercase"
              >
                Terms of Use
              </a>
            </div>
            <div className="px-2 py-1">
              <a
                href="https://playbookapp.io/privacy-policy"
                target="_blank"
                rel="noreferrer"
                className="text-center text-black text-xs font-bold uppercase"
              >
                Privacy Policy
              </a>
            </div>
          </div>
          <div className="text-center text-gray-600 text-xs font-normal">
            Playbook Technologies :: 55 Riverwalk Place :: West New York NJ
            07093
          </div>
        </div>
      </div>
    </div>
  );
};
